import { Button, Grid, IconButton, Typography } from '@mui/material';
import React, { Fragment, useState } from 'react';
import Create from '../create';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';

function ExtraData({ data }) {
    if (data?.extra_data == null) {
        return null
    }
    const parsedData = JSON.parse(data?.extra_data);
    const keyValuePairs = Object.entries(parsedData).map(([key, value]) => (
        { key, value }
    ));

    return (
     <div className="pop-det-cntr source extradata sourse-list">
    <div className="source-list extradata">

        {keyValuePairs.map(({ key, value }, index) => (
            <Fragment key={index}>
                <div className="pop-det-text extra-data-row">

                    <Typography
                        variant="body1"
                        component="h2"
                        className="extra-data-key"
                    >
                        {key}:
                    </Typography>

                    <Typography
                        variant="body2"
                        className="extra-data-value"
                    >
                        {value}
                    </Typography>

                </div>
            </Fragment>
        ))}

        <div className="pop-det-text extra-data-row">

            <Typography
                variant="body1"
                component="h2"
                className="extra-data-key"
            >
                Source URL:
            </Typography>

            <Typography
                variant="body2"
                className="extra-data-value"
            >
                {data.source_url}
            </Typography>

        </div>

    </div>
</div>
    );
}

export default ExtraData;
